import React from 'react'
import { DefaultLayout } from '../../layouts'
import { Container, Breadcrumb, User, SimplePageHeader, /* ButtonBookmark */ } from '../../components'
// import auth from '../../utils/auth'

const routes = [
  {
    name: 'Home',
    route: '/'
  },
  {
    name: 'Program',
    route: '/program'
  },
  {
    name: 'Breaking Down the Walls',
    route: '/program/1/detail'
  }
]

const ProgramStory = () => {
  // const { isOfficial, isVerified } = auth()
  // const bookmarkable = isOfficial || isVerified
  // const [bookmarked, setBookmarked] = React.useState(false)

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <Container className="py-5 pb-10 lg:py-20 lg:pb-20" color="#f5f5f5">
        <div className="lg:w-8/12 mx-auto">
          <Breadcrumb className="mb-1 lg:mb-5" routes={routes} />

          <h1 className="text-2xl lg:text-4xl font-bold lg:leading-tight mb-5 font-primary">
            Story of Change - Breaking Down the Walls
          </h1>

          <User />

          <hr className="my-8 lg:my-10"/>

          <div className="blog-content">
            <h6>
              <b>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</b>
            </h6>
            <p>
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
            </p>
            <p>
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
            </p>
            <p>
              Non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
            </p>
          </div>
        </div>
      </Container>
    </DefaultLayout>
  )
}

export { ProgramStory }
